module.exports = __webpack_public_path__ + "static/media/Underbone.8711353d.svg";